import { render, staticRenderFns } from "./ProjectGroupManager.vue?vue&type=template&id=4a0a6d7e&scoped=true"
import script from "./ProjectGroupManager.vue?vue&type=script&lang=js"
export * from "./ProjectGroupManager.vue?vue&type=script&lang=js"
import style0 from "./ProjectGroupManager.vue?vue&type=style&index=0&id=4a0a6d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a6d7e",
  null
  
)

export default component.exports